import type { Data } from '@repo/strapi'
import { Close } from '@/components/icons/Close'
import { Done } from '@/components/icons/Done'

export const PricingCompareCell = ({
	planItem,
}: {
	planItem?: Data.Component<'shared.pricing-plan'> | null
}) => {
	if (!planItem) {
		return <Close className="size-5 text-peach-900" />
	}

	if (planItem.text) {
		return <span className="text-neutral-500 text-center">{planItem.text}</span>
	}

	if (planItem.isChecked) {
		return <Done className="size-5 text-lime-800" />
	}

	return <Close className="size-5 text-peach-900" />
}

export default PricingCompareCell
